<dms-control [dmsTraduction]="this.dmsTraduction" >
	<dms-simpleselect></dms-simpleselect>
</dms-control>